import React from 'react';
import ReactDOM from 'react-dom/client';
import { IntlProvider } from 'react-intl';
import { DEFAULT_LOCALE, getMessagesForLocale, resolveLocale } from '@hypedirector/i18n';
import { App } from './App';
import { firebaseService } from './services/firebase.service';
import { applyConsoleOverrides, errorLog } from './utils/logger';
import './styles/index.css';

const LANGUAGE_STORAGE_KEY = 'hypedirector-landing-locale';

// Get locale from localStorage first, then browser, then default to English
function getInitialLocale(): string {
  if (typeof window !== 'undefined') {
    const savedLocale = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (savedLocale) {
      return resolveLocale(savedLocale);
    }
  }
  // Default to English if browser language is not supported
  const browserLocale = typeof navigator !== 'undefined' ? navigator.language : DEFAULT_LOCALE;
  const resolved = resolveLocale(browserLocale);
  // Ensure we default to English if resolved locale is not in our supported list
  return resolved || DEFAULT_LOCALE;
}

const locale = getInitialLocale();
const messages = getMessagesForLocale(locale);

applyConsoleOverrides();

// Initialize Firebase
firebaseService.initialize().catch(error => {
  errorLog('Failed to initialize Firebase:', error);
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <IntlProvider locale={locale} defaultLocale={DEFAULT_LOCALE} messages={messages}>
      <App />
    </IntlProvider>
  </React.StrictMode>
);

